import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import CustomerReport from './layouts/CustomerReport'
import SalesRepReport from './layouts/SalesRepReport'
import SalesRepTypeReport from './layouts/SalesRepTypeReport'

const DiscountReportPageCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Profitability',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
]

const DiscountReportPage = () => {
  return (
    <Navigation
      baseUrl='/analytics/profitability/discount-report'
      breadcrumbs={DiscountReportPageCrumbs}
      pageTitle='Discount Report'
      navigationData={[
        {
          key: 'customer-report',
          label: 'Customer',
          component: <CustomerReport />,
        },
        {
          key: 'sales-rep-report',
          label: 'Sales Representative',
          component: <SalesRepReport />,
        },
        {
          key: 'sales-rep-type-report',
          label: 'Sales Representative Type',
          component: <SalesRepTypeReport />,
        },
      ]}
    />
  )
}

export default DiscountReportPage
